// track.js — thin alias over the ONE telemetry pipeline (lib/analytics.trackEvent → GA4 + /api/event + local ring).
// Before Sep 2026 this only reached gtag, so every `track("…_completed")` (daily challenge, tournament, funnel(),
// school evidence…) was invisible to the North-Star funnel (/api/metrics) — the reason it showed 0 completions.
import { trackEvent } from "@/lib/analytics";

const recent = new Map();

export function track(event, params = {}) {
  try {
    const key = `${event}|${JSON.stringify(params)}`;
    const now = Date.now();
    if (recent.get(key) && now - recent.get(key) < 2000) return; // collapse accidental double-fires
    recent.set(key, now);
    if (recent.size > 200) recent.delete(recent.keys().next().value);
    trackEvent(event, params);
  } catch {
    /* never let analytics break the app */
  }
}

export default track;
